module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8447/img/cta-blobs.png"